import { useEffect, useState } from 'react';

export type Translate = (key: string, vars?: Record<string, string | number | null | undefined>) => string;

/** Fills {name} placeholders; a translation keeps the same placeholders as its English key. */
export const fill = (text: string, vars?: Record<string, string | number | null | undefined>): string =>
  vars ? text.replace(/\{(\w+)\}/g, (match, name) => (vars[name] === undefined || vars[name] === null ? match : String(vars[name]))) : text;

export const makeT =
  (language: Record<string, string> | null | undefined): Translate =>
  (key, vars) =>
    fill(language?.[key] ?? key, vars);

const hostLanguage = (): Record<string, string> | null => (window as any).languageContext?.language ?? null;

/** The host's translation bag (keys are the English strings), as every module page reads it. */
export const useLanguage = () => {
  const [language, setLanguage] = useState<Record<string, string> | null>(hostLanguage);
  const context = (window as any).languageContext;
  useEffect(() => {
    if (hostLanguage()) setLanguage(hostLanguage());
  }, [context]);
  return { language, t: makeT(language) };
};
